import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background: linear-gradient(135deg, ${props => props.theme.colors.background.darker} 0%, 
                ${props => props.theme.colors.background.dark} 50%, 
                ${props => props.theme.colors.background.darker} 100%);
    color: ${props => props.theme.colors.text.primary};
    overflow-x: hidden;
    scroll-behavior: smooth;
    min-height: 100vh;
  }

  html {
    scroll-behavior: smooth;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.background.darker};
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.primary[500]};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.accent.blue};
  }
`